var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"no-close-on-backdrop":"","hide-footer":"","no-close-on-esc":""},scopedSlots:_vm._u([{key:"modal-header",fn:function(){return [_c('h5',[_vm._v("Bitte warten...")])]},proxy:true}])},[_c('b-container',[_c('b-spinner',{attrs:{"variant":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }